import { earliestVisibleWave } from '@context/dashboardFetchWave'
import { DashboardSection } from '@constants/Dashboard/dashboard.enums'

export type FinanceSectionWaves = {
  practiceRevenue: number | null
  production: number | null
  collection: number | null
  productionByDepartment: number | null
  treatmentValue: number | null
  arAging: number | null
  outstanding: number | null
  claims: number | null
  hygiene: number | null
  arOver90: number | null
  productionByProcedure: number | null
  productionPerProvider: number | null
}

function show(section: DashboardSection, hiddenSections: Set<string>): boolean {
  return !hiddenSections.has(section)
}

export function buildFinanceSectionWaves(
  hiddenSections: Set<string>,
): FinanceSectionWaves {
  const visible = (section: DashboardSection): boolean =>
    show(section, hiddenSections)
  return {
    practiceRevenue: visible(DashboardSection.PracticeRevenueOverview)
      ? 0
      : null,
    production: visible(DashboardSection.Production) ? 0 : null,
    collection: earliestVisibleWave([
      [visible(DashboardSection.CollectionPerformance), 0],
      [visible(DashboardSection.InsuranceVsPatientCollection), 1],
      [
        visible(DashboardSection.Collection) ||
          visible(DashboardSection.CollectionRatio) ||
          visible(DashboardSection.CollectionMetric) ||
          visible(DashboardSection.CollectionRate),
        2,
      ],
    ]),
    productionByDepartment: earliestVisibleWave([
      [visible(DashboardSection.DentistVsHygienistProduction), 1],
      [visible(DashboardSection.ProductionByDepartment), 2],
    ]),
    treatmentValue: visible(DashboardSection.TreatmentValue) ? 1 : null,
    arAging: earliestVisibleWave([
      [visible(DashboardSection.ArAging), 1],
      [visible(DashboardSection.ArAgingMetric), 2],
    ]),
    outstanding: visible(DashboardSection.OutstandingBalance) ? 1 : null,
    claims: visible(DashboardSection.Claims) ? 1 : null,
    hygiene:
      visible(DashboardSection.NetHygieneProductionFinance) ||
      visible(DashboardSection.ProductionPerHygieneVisitFinance)
        ? 2
        : null,
    arOver90: visible(DashboardSection.ArOver90Day) ? 2 : null,
    productionByProcedure: visible(DashboardSection.ProductionByProcedure)
      ? 2
      : null,
    productionPerProvider: visible(DashboardSection.ProductionPerProvider)
      ? 2
      : null,
  }
}
